import { useRouter } from "next/router";
import LoraDetails from "@/components/molecules/LoraDetails";
export default function LoraPage() {
  const router = useRouter();
  const {
    id
  } = router.query;
  return <div className="min-h-screen bg-background text-foreground" data-sentry-component="LoraPage" data-sentry-source-file="index.tsx">
            <LoraDetails loraId={id as string} data-sentry-element="LoraDetails" data-sentry-source-file="index.tsx" />
        </div>;
}